/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Readiness_DetrainingInputs */

const en_ui_readiness_detraining = /** @type {(inputs: Ui_Readiness_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detraining`)
};

const de_ui_readiness_detraining = /** @type {(inputs: Ui_Readiness_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbau`)
};

/**
* | output |
* | --- |
* | "Detraining" |
*
* @param {Ui_Readiness_DetrainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_readiness_detraining = /** @type {((inputs?: Ui_Readiness_DetrainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Readiness_DetrainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_readiness_detraining(inputs)
	return de_ui_readiness_detraining(inputs)
});